import { ChangeEvent, FC, MouseEvent } from 'react';

// middlewares
import {
  LinkConfigurationSelectOutputData,
  LinkConfigurationsOutputData,
  OpenInputType,
  SubscriptionInputType,
} from '../../../../middlewares/Open/openTypes';

// components
import CustomSelect from '../../common/CustomSelect';

// icon
import { ReactComponent as AlertIcon } from '../../../../assets/feather/alert-octagon.svg';
import { ReactComponent as TrashIcon } from '../../../../assets/feather/trash-2.svg';

interface SelectFieldProps {
  inputs: OpenInputType | SubscriptionInputType;
  linkConfiguration: LinkConfigurationsOutputData;
  dismissed: boolean;
  onDismissField: (name: string, dismiss: boolean) => void;
  error: string | null;
  optionLabel: string;
  handleChange: (e: ChangeEvent<HTMLSelectElement>) => void;
}

const SelectField: FC<SelectFieldProps> = (props) => {
  const {
    inputs,
    linkConfiguration,
    dismissed,
    onDismissField,
    error,
    optionLabel,
    handleChange,
  } = props;

  const handleDismissButton = (e: MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    onDismissField(linkConfiguration.name, true);
  };

  const parseOptions = (
    data: LinkConfigurationSelectOutputData[] | { [key: string]: string[] }
  ) => {
    if (Array.isArray(data)) {
      return data.map(
        (v: { value: { label: string; value: string } }) => v.value
      );
    }
    const values = data[optionLabel] as Array<string>;
    return values.map((v: string) => ({ label: v, value: v }));
  };

  return (
    <div
      className={`mx-auto w-11/12 text-left ${linkConfiguration.hidden || dismissed ? 'hidden' : ''}`}
    >
      <div className="flex justify-between">
        <label htmlFor="name" className="text-sm font-semibold w-full mr-auto">
          {linkConfiguration.label}:
        </label>
        {linkConfiguration.dismissable && (
          <button className="max-h-4 my-auto" onClick={handleDismissButton}>
            <TrashIcon className="max-h-4 my-auto text-stone-500" />
          </button>
        )}
      </div>
      <CustomSelect
        id={linkConfiguration.name}
        placeholder=""
        name={linkConfiguration.name}
        value={(inputs[linkConfiguration.name] || '') as string | number}
        handleChange={
          handleChange as (e: ChangeEvent<HTMLSelectElement>) => void
        }
        options={parseOptions(
          linkConfiguration.data as LinkConfigurationSelectOutputData[]
        )}
        disabled={linkConfiguration.value != ''}
      />
      {error && (
        <div className="flex text-red-500">
          <AlertIcon className="h-4 my-auto" />
          <p className="text-sm">{error}</p>
        </div>
      )}
    </div>
  );
};

export default SelectField;
